import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, __experimentalDivider, __experimentalSpacer, __experimentalToggleGroupControl, __experimentalToggleGroupControlOption, SelectControl, __experimentalNumberControl as NumberControl, Button, Icon } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { link, linkOff } from '@wordpress/icons';
import ColorSelector from '../color-select/color-select.js';
import { useSelect } from '@wordpress/data';
import LabelUnit from '../label-unit/label-unit.js';
import { setAttributesResponsive } from '../../block/functions.js';
import './border.css';  

export default function BorderControl({ attributes, setAttributes }) {

    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;
    const attributeName = 'border';
    const attributeNameWithDevice = attributeName + deviceString;
    const [borderStyle, setBorderStyle] = useState(attributes?.[attributeNameWithDevice]?.style ? attributes?.[attributeNameWithDevice]?.style : 'default');

    const handleDimensionChange = (side, value) => {
        if (attributes?.[attributeNameWithDevice]?.width?.isLinked) {
            setAttributesResponsive(attributeName + '.width.top', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.right', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.bottom', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.left', value, device, setAttributes, attributes);
        } else {
            setAttributesResponsive(attributeName + '.width.' + side, value, device, setAttributes, attributes);
        }
    };

    const handleLinkToggle = () => {
        const newLinkState = !attributes?.[attributeNameWithDevice]?.width?.isLinked;
        const value = attributes?.[attributeNameWithDevice]?.width?.top ? attributes?.[attributeNameWithDevice]?.width?.top : 0;

        if (newLinkState) {
            setAttributesResponsive(attributeName + '.width.top', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.right', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.bottom', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.left', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.width.isLinked', newLinkState, device, setAttributes, attributes);
        } else {
            setAttributesResponsive(attributeName + '.width.isLinked', 0, device, setAttributes, attributes);
        }
    };

    const handleDimensionRadiusChange = (side, value) => {
        if (attributes?.[attributeNameWithDevice]?.radius?.isLinked) {
            setAttributesResponsive(attributeName + '.radius.top', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.right', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.bottom', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.left', value, device, setAttributes, attributes);
        } else {
            setAttributesResponsive(attributeName + '.radius.' + side, value, device, setAttributes, attributes);
        }
    };

    const handleRadiusLinkToggle = () => {
        const newLinkRadiusState = !attributes?.[attributeNameWithDevice]?.radius?.isLinked;
        const value = attributes?.[attributeNameWithDevice]?.radius?.top ? attributes?.[attributeNameWithDevice]?.radius?.top : 0;

        if (newLinkRadiusState) {
            setAttributesResponsive(attributeName + '.radius.top', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.right', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.bottom', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.left', value, device, setAttributes, attributes);
            setAttributesResponsive(attributeName + '.radius.isLinked', newLinkRadiusState, device, setAttributes, attributes);
        } else {
            setAttributesResponsive(attributeName + '.radius.isLinked', 0, device, setAttributes, attributes);
        }
    };

    const handleChangeBorderStyle = (newValue) => {
        setAttributesResponsive('border.style', newValue, device, setAttributes, attributes);
        setBorderStyle(newValue);
    }

    return (
        <>
            <SelectControl
                label="Style"
                value={attributes?.[attributeNameWithDevice]?.style}
                options={[
                    { label: 'Default', value: '' },
                    { label: 'None', value: 'none' },
                    { label: 'Solid', value: 'solid' },
                    { label: 'Dotted', value: 'dotted' },
                    { label: 'Dashed', value: 'dashed' },
                    { label: 'Double', value: 'double' },
                    { label: 'Groove', value: 'groove' },
                    { label: 'Inset', value: 'inset' },
                    { label: 'Outset', value: 'outset' },
                    { label: 'Ridge', value: 'ridge' },
                ]}
                labelPosition="edge"
                onChange={(newValue) => handleChangeBorderStyle(newValue)}
                className="softlite-select-control"
            />
            {['solid', 'dotted', 'dashed', 'double', 'groove', 'inset', 'outset', 'ridge'].includes(borderStyle) && (
                <>
                    <LabelUnit
                        label="Width"
                        attributes={attributes}
                        setAttributes={setAttributes}
                        unit={attributes?.[attributeNameWithDevice]?.width?.unit ? attributes?.[attributeNameWithDevice]?.width?.unit : 'px'}
                        attributeName={`${attributeName}.width.unit`}
                    />
                    <div className="softlite-border-dimension-control">
                        <div className="softlite-border-control softlite-no-border-right">
                            <NumberControl
                                value={attributes?.[attributeNameWithDevice]?.width?.top}
                                placeholder={__('Top', 'softlite')}
                                onChange={(value) => handleDimensionChange('top', value)}
                                min={0}
                            />
                        </div>
                        <div className="softlite-border-control softlite-no-border-right">
                            <NumberControl
                                value={attributes?.[attributeNameWithDevice]?.width?.right}
                                placeholder={__('Right', 'softlite')} // Thay đổi subdoamin
                                onChange={(value) => handleDimensionChange('right', value)}
                                min={0}
                            />
                        </div>
                        <div className="softlite-border-control softlite-no-border-right">
                            <NumberControl
                                value={attributes?.[attributeNameWithDevice]?.width?.bottom}
                                placeholder={__('Bottom', 'softlite')}
                                onChange={(value) => handleDimensionChange('bottom', value)}
                                min={0}
                            />
                        </div>
                        <div className="softlite-border-control softlite-no-border-right">
                            <NumberControl
                                value={attributes?.[attributeNameWithDevice]?.width?.left}
                                placeholder={__('Left', 'softlite')}
                                onChange={(value) => handleDimensionChange('left', value)}
                                min={0}
                            />
                        </div>
                        <div className="softlite-border-control">
                            <Button
                                onClick={() => handleLinkToggle()}
                                className={attributes?.[attributeNameWithDevice]?.width?.isLinked ? 'softlite-button-linked softlite-linked' : 'softlite-button-linked softlite-unlinked'}
                            >
                                {<Icon icon={attributes?.[attributeNameWithDevice]?.width?.isLinked ? link : linkOff} size={18} />}
                            </Button>
                        </div>
                    </div>
                    <__experimentalSpacer marginTop="10px">
                        <ColorSelector
                            attributes={attributes}
                            setAttributes={setAttributes}
                            attributeName="border.color"
                        />
                    </__experimentalSpacer>
                    <ColorSelector
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeName="border.hoverColor"
                        label="Hover Color"
                    />
                </>
            )}

            <__experimentalDivider />
            <LabelUnit
                label="Radius"
                attributes={attributes}
                setAttributes={setAttributes}
                unit={attributes?.[attributeNameWithDevice]?.radius?.unit ? attributes?.[attributeNameWithDevice]?.unit : 'px'}
                attributeName={`${attributeName}.radius.unit`}
            />
            <div className="softlite-border-dimension-control">
                <div className="softlite-border-control softlite-no-border-right">
                    <NumberControl
                        value={attributes?.[attributeNameWithDevice]?.radius?.top}
                        placeholder={__('Top', 'softlite')}
                        onChange={(value) => handleDimensionRadiusChange('top', value)}
                        min={0}
                    />
                </div>
                <div className="softlite-border-control softlite-no-border-right">
                    <NumberControl
                        value={attributes?.[attributeNameWithDevice]?.radius?.right}
                        placeholder={__('Right', 'softlite')}
                        onChange={(value) => handleDimensionRadiusChange('right', value)}
                        min={0}
                    />
                </div>
                <div className="softlite-border-control softlite-no-border-right">
                    <NumberControl
                        value={attributes?.[attributeNameWithDevice]?.radius?.bottom}
                        placeholder={__('Bottom', 'softlite')}
                        onChange={(value) => handleDimensionRadiusChange('bottom', value)}
                        min={0}
                    />
                </div>
                <div className="softlite-border-control softlite-no-border-right">
                    <NumberControl
                        value={attributes?.[attributeNameWithDevice]?.radius?.left}
                        placeholder={__('Left', 'softlite')}
                        onChange={(value) => handleDimensionRadiusChange('left', value)}
                        min={0}
                    />
                </div>
                <div className="softlite-border-control">
                    <Button
                        onClick={() => handleRadiusLinkToggle()}
                        className={attributes?.[attributeNameWithDevice]?.radius?.isLinked ? 'softlite-button-linked softlite-linked' : 'softlite-button-linked softlite-unlinked'}
                    >
                        {<Icon icon={attributes?.[attributeNameWithDevice]?.radius?.isLinked ? link : linkOff} size={18} />}
                    </Button>
                </div>
            </div>
        </>
    );
}
